// Shared reset helpers for the joint-holder / minor form's contact fields.
// Both the mobile Add and Edit flows (JointHolderBottomSheet, EditJointHolderScreen,
// SelectJointHolderScreen) need to clear the mobile/email + their "belongs to"
// relation when the user abandons an unverified OTP step. The helpers take a
// generic setFieldValue so they work with both the Formik render-prop form
// (setFieldValue) and the ref-based form (formikRef.current?.setFieldValue).

type SetFieldValue = (field: string, value: unknown) => void;

export const resetMobileFields = (setFieldValue?: SetFieldValue | null) => {
  setFieldValue?.("mobileNo", "");
  setFieldValue?.("mobileBelongsTo", "");
};

export const resetEmailFields = (setFieldValue?: SetFieldValue | null) => {
  setFieldValue?.("email", "");
  setFieldValue?.("emailBelongsTo", "");
};
